module.exports = __webpack_public_path__ + "static/media/ball_4_9.a0bc9d0d.mp3";